<template>
  <div class="placeholder-container">
    <div>
      <p class="placeholder-title">
        <b>{{ title }}</b>
      </p>
    </div>
    <p class="placeholder-text">
      {{ text }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'PublicPagesPlaceholder',
  props: ['title', 'text'],
  components: {},
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {},
  beforeCreate() {},
  destroyed() {},
}
</script>

<style lang="scss" scoped>
@import '@/styles/Typography';
.placeholder-container {
  text-align: center;
}

.placeholder-title {
  font-size: 20px;
  line-height: 2rem;
  color: $midnight;
}

.placeholder-text {
  margin-top: 12px;
  padding: 0 12px;
  line-height: 1.3125rem;
  font-size: 0.875rem;
  color: $strom;
}

@media (min-width: 480px) and (orientation: landscape) {
}

@media (min-width: 544px) {
}

@media (min-width: 768px) {
}

@media (min-width: 1200px) {
  .placeholder-container {
    max-width: 500px;
    svg {
      width: unset;
      height: unset;
    }
  }

  .placeholder-title {
    font-size: 24px;
  }
  .placeholder-text {
    margin-top: 18px;
    line-height: 1.5rem;
    font-size: 1rem;
    padding: 0;
  }
}
</style>
